module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/pick_up_minis_werbespot_bauarbeiter_small.jpg";